var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"mx-auto",staticStyle:{"background-color":"#fafafa"}})
}
var staticRenderFns = []

export { render, staticRenderFns }